import { render, staticRenderFns } from "./FactoryContactPersonSelect.vue?vue&type=template&id=b1fce840&"
import script from "./FactoryContactPersonSelect.vue?vue&type=script&lang=js&"
export * from "./FactoryContactPersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./FactoryContactPersonSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
